import { useEffect, useState } from "react";
import { fetchSpareCategories, fetchSpares } from "../api/spares";
import ArrowRight from "../assets/icons/arrow-right.svg";
import partner1 from "../assets/parts/partner-1.png";
import partner2 from "../assets/parts/partner-2.png";
import partner3 from "../assets/parts/partner-3.png";
import partner4 from "../assets/parts/partner-4.png";
import partner5 from "../assets/parts/partner-5.png";
import partner6 from "../assets/parts/partner-6.png";
import { Text } from "../components/Text";
import { ListingCard } from "./category-page";
import NavBar from "../components/navigation";
import Footer from "../components/Footer";


// ── Icons ──────────────────────────────────────────────────────

function SearchIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
      <path d="M21 21l-4.3-4.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function FilterIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 6h16M7 12h10M10 18h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function ChatIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 11.5a8.38 8.38 0 0 1-4.5 7.5 8.5 8.5 0 0 1-8.9-.4L3 21l1.9-4.6a8.38 8.38 0 0 1-.9-3.9 8.5 8.5 0 0 1 8.5-8.5h.5a8.48 8.48 0 0 1 8 8v.5z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// ── Data ───────────────────────────────────────────────────────
// Sponsor and partner content below is placeholder — swap in your own
// advertiser and brand-partner details and images.

const SPONSOR = {
  tagline: "Your Trusted Auto Parts Supplier",
  name: "MyCar Parts Co.",
  phone: "+254 700 000 000",
  whatsapp: "254700000000",
  email: "hello@mycarapp.co.ke",
};

const PARTNER_BRANDS = Array.from({ length: 8 }, (_, i) => ({
  name: `Partner ${i + 1}`,
  logo: `/assets/parts/partners/partner-${i + 1}-logo.png`,
  image: `/assets/parts/partners/partner-${i + 1}.png`,
}));

const CATEGORIES = [
  {
    slug: "service-parts",
    title: "Service Parts",
    apiCategories: ["filters", "fluids", "belts", "cooling", "fuel", "exhaust"],
    image: "/assets/images/thumbnails/service-parts.jpg",
  },
  {
    slug: "tyres-and-rims",
    title: "Tyres and Rims",
    apiCategories: ["brakes", "wheels"],
    image: "/assets/images/thumbnails/tyres.jpg",
  },
  {
    slug: "suspension-and-steering",
    title: "Suspension and Steering",
    apiCategories: ["suspension", "steering"],
    image: "/assets/images/thumbnails/suspension.jpg",
  },
  {
    slug: "vehicle-batteries",
    title: "Vehicle Batteries",
    apiCategories: ["electrical", "batteries"],
    image: "/assets/images/thumbnails/batteries.jpg",
  },
  {
    slug: "brakes",
    title: "Brakes",
    apiCategories: ["brakes"],
    image: "/assets/images/thumbnails/brakes.jpg",
  },
  {
    slug: "electrical-and-lighting",
    title: "Electrical and Lighting",
    apiCategories: ["electrical"],
    image: "/assets/images/thumbnails/electrical.jpg",
  },
  {
    slug: "engine-gearbox-and-transmission",
    title: "Engine, Gearbox and Transmission",
    apiCategories: ["engine", "transmission"],
    image: "/assets/images/thumbnails/engine.jpg",
  },
  {
    slug: "body-parts",
    title: "Body Parts",
    apiCategories: ["body"],
    image: "/assets/images/thumbnails/body.jpg",
  },
  {
    slug: "vehicle-accessories",
    title: "Vehicle Accessories",
    apiCategories: ["interior", "other"],
    image: "/assets/images/thumbnails/accessories.jpg",
  },
];

// ── Sponsor strip ──────────────────────────────────────────────

function SponsorBanner({ sponsor }) {
  return (
    <div className="flex w-full shrink-0 flex-col justify-center bg-red-700 px-8 py-8 text-white md:w-72">
      <p className="text-xs font-semibold uppercase tracking-wide text-red-100">{sponsor.tagline}</p>
      <h2 className="mt-1 text-2xl font-bold">{sponsor.name}</h2>
      <div className="mt-6 space-y-2 text-sm">
        <a
          href={`https://wa.me/${sponsor.whatsapp}`}
          className="flex items-center gap-2 font-semibold hover:text-red-100"
        >
          <ChatIcon />
          {sponsor.phone}
        </a>
        <a href={`mailto:${sponsor.email}`} className="block text-red-100 hover:text-white">
          {sponsor.email}
        </a>
      </div>
    </div>
  );
}

function PartnerStrip({ partners }) {
  return (
    <div className="flex flex-1 items-center justify-between gap-8 overflow-x-auto bg-gray-50 px-6 py-6">
     
      <img src={partner1} alt="Partner 1" className="h-24 w-auto object-contain" />
      <img src={partner2} alt="Partner 2" className="h-24 w-auto object-contain" />
      <img src={partner3} alt="Partner 3" className="h-12 w-auto object-contain" />
      <img src={partner4} alt="Partner 4" className="h-16 w-auto object-contain" />
      <img src={partner5} alt="Partner 5" className="h-25 w-auto object-contain" />
      <img src={partner6} alt="Partner 6" className="h-24 w-auto object-contain" />
    </div>
  );
}
// ── Search bar ─────────────────────────────────────────────────

function SearchBar({ value, onChange, onSubmit }) {
  return (
    <div className="mx-auto max-w-4xl">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">Find the right part</p>
      <form onSubmit={onSubmit} className="flex items-center gap-2 rounded-xl bg-white p-2 pl-1">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600">
          <SearchIcon />
        </span>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search parts, tyres, batteries..."
          className="min-w-0 flex-1 bg-transparent text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none"
        />
        <button
          type="submit"
          className="shrink-0 rounded-lg bg-red-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          Search
        </button>
        <button
          type="button"
          aria-label="Filter results"
          className="shrink-0 rounded-lg bg-gray-100 p-2.5 text-gray-500 transition-colors hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          <FilterIcon />
        </button>
      </form>
    </div>
  );
}

// ── Category grid ──────────────────────────────────────────────

function ProgressDivider() {
  return (
    <div className="my-4 flex items-center" aria-hidden="true">
      <div className="h-0.5 w-1/3 rounded-full bg-red-600" />
      <div className="h-1.5 w-1.5 shrink-0 -translate-x-px rounded-full bg-gray-300" />
      <div className="h-0.5 flex-1 rounded-full bg-gray-200" />
    </div>
  );
}

function SubcategoryRow({ name, count }) {
  return (
    <div className="flex items-center justify-between gap-3 py-1 text-sm">
      <span className="text-gray-600">{name}</span>
      <span className="text-gray-400">({count})</span>
    </div>
  );
}

function CategoryCard({ category }) {
  return (
    <div className="flex flex-col rounded-2xl border border-gray-200 bg-white p-5 transition-colors hover:border-gray-300">
      <img src={category.image} alt={category.title} className="mx-auto h-24 w-24 object-contain" />
      <h3 className="mt-4 text-center font-semibold text-gray-900">{category.title}</h3>
      <p className="text-center text-sm text-gray-400">{category.count.toLocaleString()} listings</p>

      <ProgressDivider />

      <a
        href={`/parts/${category.slug}`}
        className="mt-4 text-sm font-semibold text-red-700 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
      >
        Explore more <img src={ArrowRight} alt="" className="inline-block h-4 w-4" />
      </a>
    </div>
  );
}

// ── Main page ──────────────────────────────────────────────────

export default function Parts({ onSearch }) {
  const [query, setQuery] = useState("");
  const [categoryCounts, setCategoryCounts] = useState({});
  const [categoryError, setCategoryError] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState("");

  useEffect(() => {
    let active = true;
    fetchSpareCategories()
      .then((categories) => {
        if (!active) return;
        setCategoryCounts(categories.reduce((counts, item) => {
          counts[item.category] = item.count;
          return counts;
        }, {}));
      })
      .catch((error) => {
        if (active) setCategoryError(error.message || "Unable to load category counts.");
      });

    return () => {
      active = false;
    };
  }, []);

  const categoriesWithCounts = CATEGORIES.map((category) => ({
    ...category,
    count: category.apiCategories.reduce((total, name) => total + (categoryCounts[name] || 0), 0),
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const search = query.trim();

    onSearch?.(search);
    setSearchError("");

    if (!search) {
      setSearchResults(null);
      return;
    }

    setSearchLoading(true);
    try {
      const results = await fetchSpares({ search });
      setSearchResults(Array.isArray(results) ? results : []);
    } catch (error) {
      setSearchResults([]);
      setSearchError(error.message || "Unable to search parts.");
    } finally {
      setSearchLoading(false);
    }
  };

  return (
    <>
    <NavBar />
    <div className="min-h-screen bg-gray-50">
      <section className="flex flex-col md:flex-row">
        <SponsorBanner sponsor={SPONSOR} />
        <PartnerStrip partners={PARTNER_BRANDS} />
      </section>

      <section className="bg-gray-900 px-4 py-8 md:px-10">
        <SearchBar value={query} onChange={setQuery} onSubmit={handleSubmit} />
      </section>

      <main className="mx-auto max-w-7xl px-4 py-12 md:px-10">
        <h1 className="text-center text-3xl font-bold text-gray-900">Parts &amp; Accessories for your Vehicle</h1>
        <p className="mt-2 text-center text-gray-500">Explore parts with guaranteed compatibility.</p>
        {categoryError && <p className="mt-3 text-center text-sm text-red-600">{categoryError}</p>}

        {searchResults === null ? (
          <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
            {categoriesWithCounts.map((category) => (
              <CategoryCard key={category.slug} category={category} />
            ))}
          </div>
        ) : (
          <section className="mt-10">
            <h2 className="text-2xl font-bold text-gray-900">
              Search results for &ldquo;{query.trim()}&rdquo;
            </h2>
            {searchLoading && <p className="py-12 text-center text-gray-500">Searching parts...</p>}
            {!searchLoading && searchError && <p className="py-12 text-center text-red-600">{searchError}</p>}
            {!searchLoading && !searchError && searchResults.length === 0 && (
              <p className="py-12 text-center text-gray-500">No parts match your search.</p>
            )}
            {!searchLoading && !searchError && searchResults.length > 0 && (
              <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {searchResults.map((item) => (
                  <ListingCard key={item.id} item={item} type="spare" />
                ))}
              </div>
            )}
          </section>
        )}
      </main>
    </div>
    <Footer />
    </>
  );
}